module.exports = __webpack_public_path__ + "static/media/tokenomics-title.4f496bd6.png";